export default __webpack_public_path__ + "static/media/helper-title.d6ee0a51.png";